import { z } from "zod";
export const ActorEmail = z.object({
    type: z.literal("email"),
    email: z.string()
});
export const ActorSlackUser = z.object({
    type: z.literal("slack_user"),
    slackUserId: z.string()
});
export const ActorSuperwallUser = z.object({
    type: z.literal("superwall_user"),
    superwallUserId: z.string()
});
export const Actor = z.discriminatedUnion("type", [
    ActorEmail,
    ActorSlackUser,
    ActorSuperwallUser
]);
